import { useCallback, useEffect, useRef, useState } from "react";

export const TOAST_MS = 3600;
const TONES = ["ok", "warn", "bad", "info"];

// One message at a time: a new say() replaces whatever is showing.
export default function useToast(ms = TOAST_MS) {
  const [toast, setToast] = useState(null);
  const timer = useRef(null);
  const seq = useRef(0);

  const clear = useCallback(() => {
    clearTimeout(timer.current);
    timer.current = null;
    setToast(null);
  }, []);

  const say = useCallback(
    (text, tone = "info") => {
      clearTimeout(timer.current);
      timer.current = null;
      if (!text) {
        setToast(null);
        return;
      }
      seq.current += 1;
      setToast({ id: seq.current, text, tone: TONES.includes(tone) ? tone : "info" });
      if (ms > 0) timer.current = setTimeout(() => setToast(null), ms);
    },
    [ms]
  );

  useEffect(() => () => clearTimeout(timer.current), []);

  return { toast, say, clear };
}
